import FastMarquee from "react-fast-marquee";
import { Asterisk } from "lucide-react";
import { useShop } from "../context/ShopContext";

const Marquee = () => {
  const { t } = useShop();

  return (
    <div
      className="bg-olive-pale border-y border-brown/10 py-6 overflow-hidden"
      data-testid="marquee-section"
    >
      <FastMarquee speed={25} gradient={false} pauseOnHover>
        {t.marquee.map((word) => (
          <span key={word} className="flex items-center">
            <span className="font-serif text-2xl md:text-3xl italic text-brown/80 mx-10 whitespace-nowrap">
              {word}
            </span>
            <Asterisk size={20} className="text-olive shrink-0" />
          </span>
        ))}
      </FastMarquee>
    </div>
  );
};

export default Marquee;
